<template>
  <div>
    <q-form ref="editForm">
      <c-card title="평가계획 기본정보" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-12" style="margin-top: 5px">
            <c-text
              :required="true"
              :editable="editable"
              :disabled="true"
              label="평가명"
              name="assessmentName"
              v-model="assessPlan.assessmentName"
            />
          </div>
          <div class="col-12">
            <c-datepicker
              :required="true"
              :editable="editable"
              :disabled="true"
              :range="true"
              label="평가기간"
              name="period"
              v-model="assessPlan.assessmentPeriod"
            />
          </div>
          <div class="col-6">
            <c-select
              :required="true"
              :editable="editable"
              :disabled="true"
              codeGroupCd="RAM_ASSESS_TYPE_CD"
              type="edit"
              itemText="codeName"
              itemValue="code"
              name="ramAssessTypeCd"
              label="평가구분-정기/수시/최초"
              v-model="assessPlan.ramAssessTypeCd"
            />
          </div>
          <div class="col-6">
            <c-select
              :required="true"
              :editable="editable"
              :disabled="true"
              :comboItems="matrixItems"
              type="edit"
              itemText="matrixName"
              itemValue="ramMatrixId"
              name="ramMatrixId"
              label="Matrix"
              v-model="assessPlan.ramMatrixId"
            />
          </div>
          <div class="col-6">
            <c-plant
              :required="true"
              :disabled="true"
              :editable="editable"
              type="edit"
              name="plantCd"
              v-model="assessPlan.plantCd"
            />
          </div>
          <div class="col-6">
            <c-dept
              :required="true"
              :editable="editable"
              :disabled="true"
              type="edit"
              label="진행부서"
              name="assessmentManageDeptCd"
              :isFirstValue="false"
              v-model="assessPlan.assessmentManageDeptCd"
            />
          </div>
          <div class="col-6">
            <c-text
              :editable="editable"
              :disabled="true"
              label="작성자/작성일"
              name="request"
              v-model="request"
            />
          </div>
          <div class="col-6">
            <c-vendor
              :disabled="true"
              :editable="editable"
              label="외부기관(업체)"
              name="vendorCd"
              v-model="assessPlan.vendorCd"
            />
          </div>
          <div class="col-6">
            <c-field
              :required="true"
              :editable="editable"
              :disabled="true"
              :data="assessPlan"
              type="user"
              label="평가팀 리더"
              name="reviewUserId"
              v-model="assessPlan.reviewUserId"
            />
          </div>
          <div class="col-6">
            <c-field
              :required="true"
              :editable="editable"
              :disabled="true"
              :data="assessPlan"
              type="user"
              label="평가자"
              name="approvalUserId"
              v-model="assessPlan.approvalUserId"
            />
          </div>
          <div class="col-12">
            <c-textarea
              :editable="editable"
              :disabled="true"
              autogrow
              label="상세내용"
              name="remark"
              v-model="assessPlan.remark"
            />
          </div>
          <div class="col-12">
            <c-upload
              class="q-pt-md"
              :attachInfo="attachInfo"
              :editable="false"
            />
          </div>
        </template>
      </c-card>
    </q-form>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskPlanInfo",
  props: {
    assessPlan: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        plantCd: "", // 사업장 코드
        ramTechniqueCd: "", // 평가기법 코드_HAZOP/KRAS/JSA/CHECKLIST
        ramAssessTypeCd: "", // 평가구분_최초/정기/수시
        assessmentName: "", // 평가명
        assessmentStartDate: "", // 평가시작일
        assessmentEndDate: "", // 평가종료일
        assessmentPeriod: [],
        assessmentYear: "", // 평가년도
        ramStepCd: "", // 평가 진행단계 코드
        assessmentManageDeptCd: "", // 평가주관 부서 코드
        assessmentManageUserId: "", // 평가주관 담당자 ID
        ramMatrixId: null, // 위험메트릭스 번호
        sopMocId: "", // MOC 일련번호
        remark: "", // 상세내용
        workArea: "", // 작업지역
        regDtStr: "",
        regUserId: "", // 작성자 ID
        regUserName: "", // 작성자 ID
        reviewUserId: "", // 검토자 ID
        reviewDate: "", // 검토일
        approvalUserId: "", // 승인자 ID
        approvalDate: "", // 승인일
        vendorCd: "",
        sopConstructionId: "",
        chgUserId: "", // 수정자 ID
        teams: [], // 평가팀 목록
        occasions: [], // 수시 변경/추가 내역 목록
        conferences: [], // 회의 목록
        relatedDocuments: [], // 관련자료 목록
        processes: [], // 대상공정 목록
      }),
    },
    attachInfo: {
      type: Object,
      default: () => ({
        isSubmit: "",
        taskClassCd: "RISK_PLAN",
        taskKey: "",
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: true,
      matrixItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    request() {
      return (
        this.assessPlan.regUserName +
        " / " +
        this.assessPlan.regDtStr.slice(0, 10)
      );
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      this.setMatrixItems();
      // list setting
    },
    setMatrixItems() {
      this.$http.url = selectConfig.ram.matrix.list.url;
      this.$http.type = "GET";
      this.$http.param = {
        plantCd: this.assessPlan.plantCd,
        ramTechniqueCd: this.assessPlan.ramTechniqueCd,
      };
      this.$http.request((_result) => {
        this.matrixItems = _result.data;
      });
    },
  },
};
</script>
